.ei{white-space:nowrap;}